
import TiwiMixin from '../mixins/TiwiMixin';
import SocialShare from './SocialShare.vue'

export default {
  mixins: [TiwiMixin],
  components: { SocialShare },
  props: {
    count: {
      required: false,
      default: 0,
      type: Number
    },
    post: {
      type: Object,
      required: false,
      default: null
    },
  },
  data() {
    return {
      current_count: this.count,
      popup: false
    }
  },
  methods: {
    togglePopup: function () {
      this.popup = !this.popup;
    },
    closePopup: function () {
      this.popup = false;
    },
    copyLink: function() {
      this.popup = false;
      navigator.clipboard.writeText(this.post.url);
      this.toast.info('Link copiato negli appunti');
      this.onShare('link');
    },
    shareModal: function() {
      this.popup = false;
      this.toast.error('Funzione non ancora attiva');
    },
    onShare: function(via = '') {
      const self = this;
      this.popup = false;
      this.api.post('user-event/toggle', { 
        type: 'SHARE', 
        related_id: this.post.ID, 
        related_type: 'post', 
        active: true,
        allow_multiple: true,
        data: { share_via: via }
      })
        .then((response) => {
          if (response.data.success) {
            self.current_count++;
          }
        })
    }
  },
}
